import React from 'react';
import { VmcStatusDto as VmcStatus } from '../../services/openapi'
import { ApiError } from '../../services/openapi';
import { Col, Row } from 'react-bootstrap';

type VmcStatusItemProps = {    
    vmcStatus: VmcStatus;
    rowColor: string;
    className?: string;
    isSelected: boolean;
};

const VmcStatusItem = ({ vmcStatus, rowColor, className, isSelected }: VmcStatusItemProps) => {
    return (
        <>
            <Row className={("qvend-table-font " + (className ?? ""))} style={{ background: isSelected ? rowColor : (vmcStatus.vmcStatusEnum === -1 ? "red" : vmcStatus.vmcStatusEnum === 2 ? "yellow" : vmcStatus.vmcStatusEnum === 0 ? "orange" : rowColor), color: "black" }}>
                <Col xl={2} lg={2} md={3} sm={6} xs={6} className="qvend-table table-column-first">{vmcStatus.description}</Col>
                <Col xl={2} lg={2} md={3} sm={0} xs={0} className="qvend-table d-none d-md-block">{vmcStatus.lastMessageReceivedDateTime}</Col>
                <Col xl={8} lg={8} md={6} sm={6} xs={6} className="qvend-table">{vmcStatus.locationDescription}</Col>
            </Row>
        </>
    );
};

export default VmcStatusItem;
